// extracted by mini-css-extract-plugin
module.exports = {"add":"styles_add__2Aruk","select":"styles_select__1t8ki"};